
export const labelBounds = {
	Both: 'Both',
	LowerThanUpper: 'LowerThanUpper',
	GreaterThanLower: 'GreaterThanLower'
};

export const histogramContainerId = 'cross-analysis-histogram-chart';
